import { Injectable } from '@angular/core';

import { areasStorage } from "./data.service";
import {DivisaoNavigationService} from "../../divisoes/shared/divisao-navigation.service";
import {DivisoesService} from "../../divisoes/shared/divisao.service";
import {AutoCompleteService} from "../../../shared/components/autocomplete/autocomplete.service";
import {divisoesStorage} from "../../divisoes/shared/data.service";
import {FrotaNavigationService} from "../../../bens/frotas/shared/frota-navigation.service";
import {FrotasService} from "../../../bens/frotas/shared/frota.service";
import {frotasStorage} from "../../../bens/frotas/shared/data.service";

@Injectable()
export class AreaService {

    constructor(
        private _divisaoService: DivisoesService,
        private _divisaoNavigationService: DivisaoNavigationService,
        private _frotaNavigationService: FrotaNavigationService,
        private _frotaService: FrotasService,

        private _autocompleteService: AutoCompleteService
    ) { }

    //session
    setSessionStorage(item: any) {
        var object: string = JSON.stringify(item);
        sessionStorage.setItem(areasStorage + '-new', object);
    }

    getSessionStorage() {
        var item: string = sessionStorage.getItem(areasStorage + "-new");
        return JSON.parse(item);
    }

    clearSessionStorage() {
        sessionStorage.removeItem(areasStorage + "-new");
    }

    setSessionStorageFatherModule(item: any) {
        var object: string = JSON.stringify(item);
        sessionStorage.setItem(areasStorage + '-father', object);
    }

    getSessionStorageFatherModule() {
        var item: string = sessionStorage.getItem(areasStorage + "-father");
        return JSON.parse(item);
    }

    clearSessionStorageFatherModule() {
        sessionStorage.removeItem(areasStorage + "-father");
    }

    returnToOtherForm(otherForm: string, Response: any) {
        if(Response) {
            var otherFormObject: any;

            if (otherForm === divisoesStorage) {
                otherFormObject = this._divisaoService.getSessionStorage();
                otherFormObject.area = Response;
                this._divisaoService.setSessionStorage(otherFormObject);
            } else if (otherForm === frotasStorage) {
                otherFormObject = this._frotaService.getSessionStorage();
                otherFormObject.area = Response;
                this._frotaService.setSessionStorage(otherFormObject);
            }
        }

        this._autocompleteService.clearSessionStorage(areasStorage);

        if (otherForm === divisoesStorage) {
            otherFormObject = this._divisaoService.getSessionStorage();
            if (otherFormObject.id) {
                this._divisaoNavigationService.goToEdit(otherFormObject.id);
            } else {
                this._divisaoNavigationService.goToNew();
            }
        } else if (otherForm === frotasStorage) {
            otherFormObject = this._frotaService.getSessionStorage();
            var frotasRoute = otherFormObject.thisRoute;
            if (otherFormObject.id) {
                this._frotaNavigationService.goToEdit(otherFormObject.id, frotasRoute);
            } else {
                this._frotaNavigationService.goToNew(frotasRoute);
            }
        }
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/areas/shared/area.service.ts
 **/